import { useCallback, useMemo } from 'react'

import { useLazyGQLGetMeetingQuery } from 'shared/api/meetings'

/**
 * Search GraphQL `getMeeting` (legacy) is only used in active-meeting for Calendly merge paths.
 * When supergraph provides meeting detail, skip using search results so the right rail does not
 * depend on the search GraphQL API.
 */
export function useActiveMeetingSearchLazyResult(supergraphMeetingDetailEnabled) {
  const rtk = useLazyGQLGetMeetingQuery()
  const noopTrigger = useCallback(() => {}, [])
  const noopResult = useMemo(
    () => ({
      data: undefined,
      error: undefined,
      status: 'uninitialized',
      isError: false,
      isSuccess: false,
      isLoading: false,
    }),
    []
  )
  return supergraphMeetingDetailEnabled ? [noopTrigger, noopResult] : rtk
}
